/**
 * Created by Andrey Popov on 5/5/21
 */

const XsollaSocial = function () {
    this.accessToken = undefined;
    this.user = undefined;

    Social.call(this, connector.XSOLLA);
}; 

XsollaSocial.prototype = Object.create(Social.prototype);
XsollaSocial.prototype.constructor = XsollaSocial;

XsollaSocial.prototype._connect = function (callback) {
    const div = document.createElement("div");
    div.id = "xsollaLoginLayout";
    div.style.width = "100%";
    div.style.height = "100%";
    div.style.left = "0px";
    div.style.top = "0px";
    div.style.position = "absolute";
    div.style.backgroundColor = "#00000050";
    div.style.zIndex = "1000000000";
    div.style.visibility = "hidden";
    document.body.appendChild(div);

    this.accessToken = connector.dataLoader.load(SimpleDataLoader.TYPES.XSOLLA_ACCESS_TOKEN);
    if (this.accessToken) {
        this.loadUser((code) => {
            if (code === connector.CODE_SUCCEED) {
                callback(connector.STATUS_CONNECTED);
            } else {
                this.accessToken = undefined;
                connector.dataLoader.remove(SimpleDataLoader.TYPES.XSOLLA_ACCESS_TOKEN);
                callback(connector.STATUS_DISCONNECTED);
            }
        });
    } else {
        callback(connector.STATUS_CONNECTED);
    }
};

XsollaSocial.prototype.loadUser = function (callback) {
    ConnectorRestClient.get(
        "https://login.xsolla.com/api/users/me", 
        {},
        (response) => {
            this.user = response;
            callback(connector.CODE_SUCCEED);
        },
        () => {
            callback(connector.CODE_FAILED);
        },
        {
            authorization: `Bearer ${this.accessToken}`
        }
    );
};

XsollaSocial.prototype._login = function (callback) {
    let initZ2, checkInterval;

    const onPopupClosed = function () {
        window.removeEventListener("message", initZ2, false);
        document.getElementById("xsollaLoginLayout").style.visibility = "hidden";
        clearInterval(checkInterval);
    };

    let url = location.href;
    let origin = location.origin;

    url = `${url.substring(0, url.lastIndexOf("/") + 1).replace("msstart/", "")}xsolla-login.html`;

    if (connector.config.source === "msix") {
        url = `${connector.config.deployment}/publish/html5${connector.config.debugMode ? "-staging" : ""}/xsolla-login.html`;
        origin = new URL(url).origin;
    }

    initZ2 = function (e) {
        if (e.origin !== origin || e.data.type !== "xsolla" || !e.data.accessToken) {
            return;
        }
        console.log("Xsolla login response:", e.data);
        this.accessToken = e.data.accessToken;
        connector.dataLoader.save(SimpleDataLoader.TYPES.XSOLLA_ACCESS_TOKEN, this.accessToken);
        onPopupClosed();

        this.loadUser(callback);
    }.bind(this);

    const myWidth = Math.max(800, screen.width * 0.5);
    const myHeight = Math.max(600, screen.height * 0.6);
    const left = (screen.width - myWidth) / 2;
    const top = (screen.height - myHeight) / 2;

    const popup = window.open(url, "popup", `toolbar=no, location=no, directories=no, status=no, menubar=no, copyhistory=no, width=${myWidth}, height=${myHeight}, top=${top}, left=${left}`);

    if (popup) {
        window.addEventListener("message", initZ2, false);
        document.getElementById("xsollaLoginLayout").style.visibility = "visible";
        checkInterval = setInterval(() => {
            if (popup.closed) {
                onPopupClosed();
                callback();
            }
        }, 100);
    } else {
        callback();
    }
};

XsollaSocial.prototype._getUserID = function () {
    return this.user ? this.user.id : undefined;
};

XsollaSocial.prototype.isLoggedIn = function () {
    return this.user;
};

XsollaSocial.prototype.getAccessToken = function () {
    return `XS_${this.accessToken || 0}`;
};

XsollaSocial.prototype._aboutMe = function (callback) {
    ConnectorRestClient.get(
        "https://login.xsolla.com/api/users/me/social_providers", 
        {},
        (data) => {
            if (data && data.length > 0) {
                data = data[0];

                callback(connector.CODE_SUCCEED, {
                    id: connector.platform.getUserID(), // data.social_id,
                    name: data.full_name,
                    firstName: data.nickname,
                    avatar: data.picture
                });
            } else {
                console.log(`Error: ${JSON.stringify(data)}`);

                callback(connector.CODE_FAILED);
            }
        },
        () => {
            console.log("Failed loading aboutMe");

            callback(connector.CODE_FAILED);
        }, 
        {
            authorization: `Bearer ${this.accessToken}`
        }
    );
};